<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>

    <hr />
    <homework-media :id="id" />
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import HomeworkMedia from "./HomeworkMedia.vue";

export default {
  components: { HomeworkMedia },
  data: () => ({
    cardLink: "business/homework",
    cardSetLink: "business/homework",
    item: null,
    fields: [],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);

    this.fields = [
      {
        key: "discipline_id",
        label: "",
        type: "hidden",
        value: this.item["discipline_id"],
        textType: "text",
      },
      {
        key: "group_id",
        label: "",
        type: "hidden",
        value: this.item["group_id"],
        textType: "text",
      },
      {
        key: "title",
        label: "Название",
        type: "field",
    
        textType: "text",
      },
      {
        col: "col-12 col-md-6",
        label: "Выберите день",
        key: "timetable",
        type: "select",
        selectKey: "date",
        modal: "timetable",
        pushLink: `/${this.item["group_id"]}/journals/${this.item["discipline_id"]}/timetables`,
        prefix: "timetable",
      },
    ];
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
